<template>
    <div class="admin-footer" id="main-footer">
        <div class="loading-container" style="display: none;">
            <div class="loading">
                <img src="/static/images/loading.gif">
            </div>
        </div>
        © {{system_year}} Velocity Vehicle Group. All Rights Reserved. Version {{ version }}
    </div>
</template>
<script>
    import Vue from 'vue';
    import {commonMixins} from '../../../mixins/commonMixins';

    var self;
    export default {
        name: 'Footer',
        mixins: [commonMixins],
        data() {
            return {
                system_year: localStorage.getItem('system_year'),
                version: localStorage.getItem('tag'),
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.loadTag();
            self.getRole();
        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/backend/partials/Footer.vue